import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import './index.css';
import './lib/i18n';            // i18next must run before any t() call
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { LowDataProvider } from './contexts/LowDataContext';
import { InstallPrompt } from './components/shared/InstallPrompt';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { queryClient } from './lib/queryClient';

// When a new service worker takes control after a deploy, reload once so the
// page runs the latest assets instead of a stale cached bundle. Guarded to the
// returning-user case (a controller already existed) so first visits don't
// double-load.
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController && !refreshing) { refreshing = true; window.location.reload(); }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {/* Display preference, read by DeferredImage. Inside AuthProvider so
              the toggle can live on any authenticated screen. */}
          <LowDataProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
            <InstallPrompt />
            <Toaster richColors position="top-right" />
          </LowDataProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
